module.exports = __webpack_public_path__ + "static/assets/ee391d4556c47170aa89072b88669350.png";